import { cardTypeTranslation } from "@/common/constants/cards.constant";
import { formatCardNumber, formatDateTime } from "@/common/utils/formatters";
import { CardData } from "../types/card.type";
import AllCardsOwner from "../components/allCards/AllCardsOwner";
import AllCardsEquipment from "../components/allCards/AllCardsEquipment";
import RequestNewCard from "../components/allCards/RequestNewCard";
import { cardStatusTranslation } from "../constants/cardStatusTranslation.constant";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { BriefcaseBusinessIcon } from "lucide-react";
import CardNumberWithCopyButton from "@/common/components/CardNumberWithCopyButton";

export class AllCardsTransformer {
  static tableTransformer() {
    return (cards: CardData[]) => {
      return cards.map((card) => {
        return {
          ...card,
          type: cardTypeTranslation[card.type],
          created_at: formatDateTime(new Date(card.created_at)),
          updated_at: card.updated_at ? formatDateTime(new Date(card.updated_at)) : '',
          card_number:  <CardNumberWithCopyButton card={card} />,
          status: card.status ? cardStatusTranslation[card.status] : '',
          company_branch: (
            <ImageWithDisplayName
              placeholderIcon={BriefcaseBusinessIcon}
              imageUrl={card?.company?.general_information?.company_logo?.url}
              displayName={card?.company?.general_information?.fantasy_name}
              caption={card[card.owner ? 'owner' : 'equipment']?.branch?.display_name}
            />
          ),
          owner_or_equipment: card.owner ? <AllCardsOwner card={card} /> : card.equipment ? <AllCardsEquipment card={card} /> : '',
          action: <RequestNewCard id={card.id} />,
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (cards: CardData[]) => {
      return cards.map((card) => ({
        route: `/pending-cards/${card.id}`,
        items: [
          ['Número', formatCardNumber(card.last_four_digits)],
          ['Tipo', cardTypeTranslation[card.type]],
          ['Status', card.status ? cardStatusTranslation[card.status] : ''],
          ['Empresa', card[card.owner ? 'owner' : 'equipment']?.branch?.general_information?.fantasy_name],
          ['Associado', card.owner ? card.owner?.full_name : card.equipment?.license_plate || card.equipment?.official_name],
        ],
      }));
    };
  }
}
